const apiHost = process.env.REACT_APP_BUILD === 'prod'
    ? 'https://grader.lrwriters.com'
    : 'https://grader.tn-company.com';

const authApiHost = process.env.REACT_APP_BUILD === 'prod'
    ? 'https://oauth.dsh-agency.com'
    : 'https://oauth-stage.dsh-agency.com';

const apiUrl = '/api/v3';

const urls = {
    orders: apiHost + apiUrl + '/orders',
    settings: apiHost + apiUrl + '/settings',
    user: apiHost + apiUrl + '/profile',
    finances: apiHost + apiUrl + '/finances',
    tasks: apiHost + apiUrl + '/profile/tasks',
    updates: apiHost + apiUrl + '/broadcast',
    notification: apiHost + apiUrl + '/notification',
    upload: apiHost + apiUrl + '/upload',

    login: authApiHost,
    logout: `${authApiHost}/logout`,
};

export { urls };



// WEBPACK FOOTER //
// ./src/config.js